import {
  CompanyLogsDataType,
  EmpresaConsumo,
  FetchJornadaParamsType,
  FetchLogsParamsType,
  FetchPessoaEmpresaParamsDataType,
  JornadaItemType,
  JornadaMeta,
  PessoaDataType,
  PessoaDisponivelDataType,
} from "@/types/company"
import api, { api_v2 } from "../api/axios.config"
import { SegmentoDataType, SegmentoSecundarioDataType } from "@/types/segmentos"
import { toSnake } from "@/utils/caseConverter"

export const getSegmentos = async () => {
  return api.get<SegmentoDataType[]>(`app/app-category`)
}

export const getSegmentosSecundarios = async () => {
  return api.get<SegmentoSecundarioDataType[]>(`app/app-sub-category`)
}

export const getConsumoEmpresa = async (id_empresa: number) => {
  const res = await api_v2.get(`empresas/${id_empresa}/consumo`)
  return { ...res, data: toSnake(res.data.data) as EmpresaConsumo[] }
}

export const getExtratoEmpresa = async (
  id_empresa: number,
  params?: { produto?: string; grupo?: string }
): Promise<{ data: EmpresaExtrato[] }> => {
  return api.get(`empresas/${id_empresa}/extrato`, { params })
}

export const getJornadaEmpresa = async (
  id_empresa: number,
  params?: FetchJornadaParamsType
): Promise<{ data: { data: JornadaItemType[]; meta: JornadaMeta } }> => {
  const res = await api_v2.get(`empresas/${id_empresa}/jornada`, { params })
  return { ...res, data: { ...res.data, data: toSnake(res.data.data) as JornadaItemType[] } }
}

export const getLogs = async (id_empresa: number, params?: FetchLogsParamsType) => {
  return api.get<CompanyLogsDataType[]>(`empresas/${id_empresa}/logs`, {
    params,
  })
}

export const getPessoas = async (
  id_empresa: number | string,
  params?: FetchPessoaEmpresaParamsDataType
): Promise<{
  data: { data: PessoaDataType[]; params?: FetchPessoaEmpresaParamsDataType }
}> => {
  const queryString = new URLSearchParams(params as Record<string, string>).toString()

  return api.get(`empresas/${id_empresa}/pessoas${queryString ? `?${queryString}` : ""}`, {
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "0",
    },
  })
}

export const getPessoasDisponiveis = async (
  id_empresa: number,
  params?: FetchPessoaEmpresaParamsDataType
): Promise<{
  data: { data: PessoaDisponivelDataType[]; meta: { total: number } }
}> => {
  const queryString = new URLSearchParams(params as Record<string, string>).toString()

  return api_v2.get(
    `empresas/${id_empresa}/pessoas-disponiveis${queryString ? `?${queryString}` : ""}`,
    {
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    }
  )
}
